// 컨텐츠 타입 매핑 유틸리티
export const CONTENT_TYPE_MAP = {
  1: "파일",
  2: "프로그램",
  3: "비디오 강의",
  4: "오디오 강의",
  5: "전자책",
  6: "템플릿",
  7: "도구",
  8: "서비스",
  9: "코스",
  10: "번들",
  11: "API",
  12: "웹 서비스",
  13: "모바일 앱",
  14: "데스크톱 앱",
  15: "플러그인",
  16: "확장 프로그램",
} as const;

export type ContentTypeCode = keyof typeof CONTENT_TYPE_MAP;

// 컨텐츠 타입 코드를 한글로 변환하는 함수
export const getContentTypeLabel = (typeCode: number): string => {
  return CONTENT_TYPE_MAP[typeCode as ContentTypeCode] || "알 수 없는 타입";
};

// 한글을 컨텐츠 타입 코드로 변환하는 함수
export const getContentTypeCode = (label: string): number | null => {
  const entry = Object.entries(CONTENT_TYPE_MAP).find(
    ([_, value]) => value === label
  );
  return entry ? parseInt(entry[0]) : null;
};
